<div class="cashback" ngxUiLoaderBlurred [loaderId]="'loader-principal'">
    <div class="titulo-pagina">
        <div>
            <div class="col">
                @if (in_log_view) {
                    <h3>
                        <span>{{ 'repairer-manager.cashback.titulo' | translate }}</span>
                        <small>{{ 'repairer-manager.cashback.subtitulo' | translate }}</small>
                    </h3>
                }
                <a href="javascript:void(0)" (click)="carregarTela(0)" class="atualizar">{{ 'repairer-manager.cashback.atualizar' | translate }} <i class="fa fa-refresh"></i></a>
            </div>
            <div class="col">
                @if (in_log_view) {
                    <div class="widget bg-success" [ngClass]="(total_disponivel >= total_valor_minimo_retirada) ? '' : 'large'">
                        <div class="row row-table">
                            <div class="icon col-lg-4 col-md-3 bg-success-dark pv-lg">
                                <em class="fa fa-dollar fa-3x"></em>
                            </div>
                            <div class="content col-lg-8 col-md-9 pv-lg">
                                <div class="h2 mt0"><small>R$</small>{{ total_disponivel | currency:' ' }}</div>
                                <div class="subtitulo">{{ 'repairer-manager.cashback.widget.disponivel.titulo' | translate }}</div>
                                @if ((total_disponivel < total_valor_minimo_retirada)) {
                                    <div class="subtitulo-small">{{ 'repairer-manager.cashback.widget.disponivel.valor-minimo' | translate }}: <b>{{ total_valor_minimo_retirada | currency:'R$' }}</b></div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (total_disponivel >= total_valor_minimo_retirada) {
                        <input type="button" class="btn btn-light" value="{{ 'repairer-manager.cashback.widget.disponivel.botao' | translate }}" (click)="solicitarResgate()" />
                    }
                }
            </div>
            <div class="col">
                @if (in_log_view) {
                    <div class="widget bg-warning large">
                        <div class="row row-table">
                            <div class="icon col-lg-4 col-md-3 bg-warning-dark pv-lg">
                                <em class="fa fa-lock fa-3x"></em>
                            </div>
                            <div class="content col-lg-8 col-md-9 pv-lg">
                                <div class="h2 mt0"><small>R$</small>{{ total_pendente | currency:' ' }}</div>
                                <div class="subtitulo">{{ 'repairer-manager.cashback.widget.pendente.titulo' | translate }}</div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="col">
                @if (in_log_view) {
                    <div class="widget bg-primary" [ngClass]="(total_resgate_solicitado > 0) ? '' : 'large'">
                        <div class="row row-table">
                            <div class="icon col-lg-4 col-md-3 bg-primary-dark pv-lg">
                                <em class="fa fa-thumbs-up fa-3x"></em>
                            </div>
                            <div class="content col-lg-8 col-md-9 pv-lg">
                                <div class="h2 mt0"><small>R$</small>{{ total_resgatado | currency:' ' }}</div>
                                <div class="subtitulo">{{ 'repairer-manager.cashback.widget.solicitado.titulo' | translate }}</div>
                            </div>
                        </div>
                        @if (total_resgate_solicitado > 0) {
                            <div class="row row-table resgate">
                                <div class="col-md-12 text-center">
                                    <div class="subtitulo">{{'repairer-manager.cashback.widget.pendente-resgate.titulo' | translate}} <small>R$ </small>{{ total_resgate_solicitado | currency : ' '}}</div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    </div>

    @if (in_log_view) {
        <div class="col-md-12 historico">
            <div class="card card-default">
                <div class="card-header">
                    <div class="card-title">
                        <div class="d-flex d-flex align-items-center">
                            <div class="title">{{ 'repairer-manager.cashback.historico.titulo' | translate}}</div>
                            <div class="filters">
                                <div class="left-section">
                                    <div class="col-md-5">
                                        <input type="text" class="form-control" placeholder="{{ 'repairer-manager.cashback.historico.filtro-fornecedor' | translate}}" [(ngModel)]="searchTerm">
                                    </div>
                                    <div dropdown="" class="col-md-2">
                                        <select class="form-select" [(ngModel)]="periodo_id_selecionado" (change)="atualizarTransacoesFiltradas()">
                                            <option value="30">{{ 'repairer-manager.cashback.historico.filtro-periodo.ultimos-30' | translate }}</option>
                                            <option value="60">{{ 'repairer-manager.cashback.historico.filtro-periodo.ultimos-60' | translate }}</option>
                                            <option value="90">{{ 'repairer-manager.cashback.historico.filtro-periodo.ultimos-90' | translate }}</option>
                                            <option value="5000">{{ 'repairer-manager.cashback.historico.filtro-periodo.mais-antigos' | translate }}</option>
                                        </select>
                                    </div>
                                    <div dropdown="" class="col-md-2">
                                        <select class="form-select" [(ngModel)]="status_id_selecionado" (change)="atualizarTransacoesFiltradas()">
                                            <option [value]="0">{{ 'repairer-manager.cashback.historico.filtro-lancamentos.todos' | translate }}</option>
                                            <option [value]="CashbackStatusEnum.Disponivel">{{ 'repairer-manager.cashback.historico.filtro-lancamentos.disponivel' | translate }}</option>
                                            <option [value]="CashbackStatusEnum.PendenteResgate">{{ 'repairer-manager.cashback.historico.filtro-lancamentos.resgate-solicitado' | translate }}</option>
                                            <option [value]="CashbackStatusEnum.Resgatado">{{ 'repairer-manager.cashback.historico.filtro-lancamentos.resgate-efetuado' | translate }}</option>
                                            <option [value]="CashbackStatusEnum.PedidoCancelado">{{ 'repairer-manager.cashback.historico.filtro-lancamentos.cancelado' | translate }}</option>
                                        </select>
                                    </div>
                                    <div class="col-md-2 show-future-cashback" [ngClass]="{'disabled': status_id_selecionado != '0'}">
                                        <input type="checkbox" name="isBO" id="hideFutureCashback" [disabled]="status_id_selecionado != '0'" [(ngModel)]="hideFutureCashback" (change)="atualizarTransacoesFiltradas()">
                                        <label for="hideFutureCashback">{{ 'repairer-manager.cashback.historico.future-cashbacks' | translate}}</label>
                                    </div>
                                </div>
                                @if ((status_id_selecionado != '0' || searchTerm !== '' || hideFutureCashback == true)) {
                                    <div class="limpar">
                                        <a href="javascript:void(0)" (click)="limpar()">{{ 'repairer-manager.cashback.historico.limpar' | translate}}</a>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body list-group">
                    <ng-scrollbar>
                        @if (transacoesFiltradas.length == 0) {
                            <h3 style="margin-bottom: 30px; text-align: center;">{{'repairer-manager.cashback.historico.vazio' | translate}}</h3>
                        } @else {
                            @for (transacao of transacoesFiltradas; track transacao) {
                                <div class="media-box">
                                    <div class="historico-item list-group-item d-flex">
                                        <div class="col-md-1 tipo" [class]="transacao.status_class"></div>
                                        @if (!transacao.is_cashout) {
                                            <div class="col-md-5">
                                                <strong class="media-box-heading">{{transacao.veiculo}}</strong>
                                                <p class="mb-sm">
                                                    <small>{{'repairer-manager.cashback.historico.transacao.pedido' | translate}}: #{{transacao.order_id}}</small>
                                                    <br />
                                                    <small>{{'repairer-manager.cashback.historico.transacao.fornecedor' | translate}}: {{transacao.fornecedor}}</small>
                                                </p>
                                            </div>
                                        } @else {
                                            @if (transacao.is_discount_on_monthly_fee) {
                                                <div class="col-md-5">
                                                    <strong class="media-box-heading">{{'repairer-manager.cashback.historico.transacao.desconto-mensalidade' | translate}}</strong>
                                                    <p class="mb-sm">
                                                        <small>{{'repairer-manager.cashback.historico.transacao.desconto-mensalidade-mes' | translate}}: {{transacao.release_date_mes_referencia}}</small>
                                                        <br />
                                                        <br />
                                                    </p>
                                                </div>
                                            } @else {
                                                <div class="col-md-5"></div>
                                            }
                                        }
                                        <div class="col-md-4">
                                            <p class="mb-sm">
                                                <strong class="media-box-heading">
                                                    {{'repairer-manager.cashback.historico.transacao.status' | translate}}: <span class="status" [ngClass]="transacao.already_paid ? 'text-strikethrough' : ''">{{transacao.status}}</span>
                                                    @if (transacao.already_paid) {
                                                        <span class="text-strikethrough">{{'repairer-manager.cashback.historico.transacao.status-ja-pago' | translate}}</span>
                                                    }
                                                </strong>
                                                <br />
                                                @if (transacao.status_id < CashbackStatusEnum.PendenteResgate) {
                                                    <small>{{'repairer-manager.cashback.historico.transacao.data-compra' | translate}}: {{transacao.creation_date_formatada}}</small>
                                                } @else {
                                                    <small>{{'repairer-manager.cashback.historico.transacao.data-resgate-solicitacao' | translate}}: {{transacao.creation_date_formatada}}</small>
                                                }
                                                <br />
                                                @if (transacao.status_id < CashbackStatusEnum.PendenteResgate) {
                                                    <small>{{'repairer-manager.cashback.historico.transacao.data-liberacao' | translate}}: {{transacao.release_date_formatada}}</small>
                                                }
                                                @if (transacao.status_id === CashbackStatusEnum.Resgatado) {
                                                    <small>{{'repairer-manager.cashback.historico.transacao.data-resgate' | translate}}: {{transacao.release_date_formatada}}</small>
                                                }
                                            </p>
                                        </div>
                                        <div class="col-md-2 text-end valor text-tertiary"
                                            [ngClass]="{
                                                'text-gray': transacao.status_id === CashbackStatusEnum.PedidoCancelado,
                                                'text-strikethrough': transacao.status_id == CashbackStatusEnum.PedidoCancelado ||  (transacao.status_id < CashbackStatusEnum.PendenteResgate && transacao.already_paid),
                                                'text-danger': transacao.status_id >= CashbackStatusEnum.PendenteResgate
                                            }">
                                            {{transacao.status_id < CashbackStatusEnum.PendenteResgate ? '' : '-'}} {{transacao.cashback_value | currency : "R$ "}}
                                        </div>
                                    </div>
                                </div>
                            }
                        }
                    </ng-scrollbar>
                </div>
            </div>
        </div>
    }
</div>

<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
